import cookies from './util.cookie';

export const userType = () => {
  const user = cookies.get('user');
  if(user) {
    const userParse = JSON.parse(user);
    return userParse.user.roleInfo.type;
  } else {
    return 'visitor';
  }
};
